import { apiUrl, apiUrl2 } from '../../../settings'


export const getAssessmentListUrl = () => {
  return apiUrl2 + '/assessment-list'
}
export const getCallbackUrl = (assessmentId) => {
  return apiUrl2 + `/getCallback/${assessmentId}`
}
export const addAssessmentActivityUrl = () => {
  return apiUrl2 + '/add-assessment-activity'
}

export const getAssessmentActivityUrl = () => {
  return apiUrl2 + '/get-assessment-activity'
}


export const updateAssessmentViewedUrl = () => {
  return apiUrl2 + '/update-assessment-viewed'
}

export const addNewAssessmentUrl = () => {
  return apiUrl2 + '/add-new-assessment'
}

export const addReassessmentUrl = () => {
  return apiUrl2 + '/updateAssessment'
}
export const addFeedbackUrl = () => {
  return apiUrl2 + '/addFeedback'
}
export const getSingleAssessmentUrl = () => {
  return apiUrl2 + '/get-single-assessment'
}
export const notEligibleAssessmentUrl = () => {
  return apiUrl2 + '/not-eligible-assessment'
}
